function updateCartAndShippingBar() {
  let previousCartTotal = 0;

  function fetchCartTotal() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const cartTotal = data.total_price / 100;

        if (cartTotal !== previousCartTotal) {
          previousCartTotal = cartTotal;
          updateFreeShippingBar(cartTotal);
        }
      })
      .catch((error) => console.error("Error fetching cart total:", error));
  }

  function updateFreeShippingBar(cartTotal) {
    const freeShippingThreshold =
      parseFloat(document.body.getAttribute("data-threshold-price")) || 50;

    document.querySelectorAll(".free-shipping-message").forEach((message, index) => {
      const success = document.querySelectorAll(".free-shipping-success")[index];
      const remainingAmount = document.querySelectorAll(".remaining-amount")[index];
      const progress = document.querySelectorAll(".progress-bar")[index];

      if (!message || !success || !progress || !remainingAmount) return;

      let remainingAmountValue = (freeShippingThreshold - cartTotal).toFixed(2);

      if (cartTotal >= freeShippingThreshold) {
        message.style.display = "none";
        success.style.display = "block";
      } else {
        message.style.display = "block";
        success.style.display = "none";

        var currencySymbols = {
          USD: "$", EUR: "€", GBP: "£", INR: "Rs.", AUD: "A$", CAD: "$",
          JPY: "¥", CNY: "¥", SGD: "S$", HKD: "HK$", NZD: "NZ$",
          CHF: "CHF", SEK: "kr", NOK: "kr", DKK: "kr",
          RUB: "₽", ZAR: "R", BRL: "R$", MXN: "MX$",
          MYR: "RM", IDR: "Rp", PHP: "₱", THB: "฿",
          VND: "₫", KRW: "₩",
        };

        var storeCurrencyCode = Shopify.currency.active;
        var storeCurrencySymbol =
          currencySymbols[storeCurrencyCode] || storeCurrencyCode;

        remainingAmount.textContent =
          `${storeCurrencySymbol} ${remainingAmountValue}`;
      }

      let progressWidth = Math.min(
        (cartTotal / freeShippingThreshold) * 100,
        100
      );
      progress.style.width = progressWidth + "%";
    });
  }

  // 🔥 Initial load
  fetchCartTotal();

  // 🔥 Listen for Shopify cart updates (AJAX add to cart)
  document.addEventListener("ajaxComplete", function () {
    fetchCartTotal();
  });

  // 🔥 Also check every 2 seconds (fallback safety)
  setInterval(fetchCartTotal, 2000);
}

updateCartAndShippingBar();
